import React from 'react';
import PropTypes from 'prop-types';
import { EditOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';

// DS
import {
  Col,
  Row,
  VertTypography,
  VertIcon,
  VertButton,
} from '@vertem-core/vertice-ds';

// STYLES
import 'Assets/styles/default/components/Checkout/DeliveryAddressInfosStyles.less';
import { allPropertiesEmpty } from 'Utils/allPropertiesEmpty';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { handleAddressNumberOutput } from 'Utils/commons/address';

// UTILS

// DELIVERY ADDRESS INFOS COMPONENT
const DeliveryAddressInfos = ({ setHasInfosAlert, ...props }) => {
  const Shipping = useSelector(({ Shipping: data }) => data);
  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/profile`);
  };

  if (
    ((!allPropertiesEmpty(props?.address) && Shipping && !Shipping.isLoading) ||
      props.addressInvalid) &&
    !(
      props.address?.zipCode?.value === '00000000' ||
      props.address?.street?.value === 'Nao Informado' ||
      props.address?.district?.value === 'Nao Informado' ||
      props.address?.city?.value === 'Nao Informado' ||
      props.address?.state?.value === 'Nao Informado'
    )
  ) {
    return (
      <Col className="checkout-delivery-adress-infos-wrapper col-12 col-md-auto">
        <Row className="checkout-delivery-adress-infos-content">
          <Col className="col-10 col-md ">
            <VertTypography.Paragraph>
              {props?.address?.name?.value}
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              Endereço:
              <span>
                {`
                  ${props?.address?.street?.value || '-'},
                  ${handleAddressNumberOutput(props?.address?.number?.value)},
                  ${props?.address?.complement?.value || '-'}
                `}
              </span>
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              Bairro:
              <span>
                {`${props?.address?.district?.value || '-'}, ${
                  props?.address?.city?.value || '-'
                }, ${props?.address?.state?.value || '-'}`}
              </span>
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              Cep:
              <span>{props?.address?.zipCode?.value || '-'}</span>
            </VertTypography.Paragraph>
          </Col>
          <Col className="col-12 col-md-auto">
            <Row className="content-buttons">
              <Col className="col-12 col-sm-12">
                <VertButton
                  spacing="small"
                  onClick={handleEdit}
                  icon={<VertIcon size="small" component={EditOutlined} />}
                >
                  Editar endereço
                </VertButton>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    );
  } else {
    if (
      props.address?.zipCode?.value === '00000000' ||
      props.address?.street?.value === 'Nao Informado' ||
      props.address?.district?.value === 'Nao Informado' ||
      props.address?.city?.value === 'Nao Informado' ||
      props.address?.state?.value === 'Nao Informado'
    ) {
      setHasInfosAlert(true);
    }

    return (
      <Col className="checkout-delivery-adress-infos-wrapper col-12 col-md-auto">
        <Row className="checkout-delivery-adress-infos-content">
          <Col className="col-10 col-md-7 ">
            <VertTypography.Paragraph>
              Seu endereço não está atualizado!
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              Por favor, conclua o cadastro de seu endereço em{' '}
              <Link to={'/profile'}>meu endereço</Link>.
            </VertTypography.Paragraph>
          </Col>
        </Row>
      </Col>
    );
  }
};

const addressPropType = PropTypes.shape({
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
});

const addressItems = PropTypes.shape({
  city: addressPropType,
  complement: addressPropType,
  district: addressPropType,
  name: addressPropType,
  number: addressPropType,
  reference: addressPropType,
  state: addressPropType,
  street: addressPropType,
  zipCode: addressPropType,
});

DeliveryAddressInfos.propTypes = {
  address: addressItems,
  onEdit: PropTypes.func.isRequired,
  onExclude: PropTypes.func.isRequired,
  onSelected: PropTypes.func.isRequired,
  addressInvalid: PropTypes.bool,
};

export default DeliveryAddressInfos;
